import { FilterSelected } from 'libs/athos/components/collection/filters/FilterSelected'
import { GridLayoutToggle } from 'libs/athos/components/collection/filters/GridLayoutToggle'
import { ProductCount } from 'libs/athos/components/collection/filters/ProductCount'
import { useFilters } from 'libs/athos/hooks/useFilters'

export const CollectionToolbar = ({ gridCols, setGridCols }) => {
  const {
    activeFilters,
    handleRemoveFilter,
    handleClearFilters
  } = useFilters()

  const activeFilterCount = activeFilters?.size

  const handleFilterOpen = () => {
    window.dispatchEvent(new CustomEvent('filters.open'))
  }

  return (
    <div className="collection-toolbar sticky top-header-adapt hidden lg:flex items-center justify-between gap-x-gutter lg:gap-x-1 w-full h-[60px] px-margin bg-secondary z-40 has-[[data-ui=visible]]:lg-max:z-60 transition-all border-b border-y-borders-default">
      <div className={'lg:grow flex flex-row justify-start gap-x-1'}>
        <button
          className={'hidden lg:flex items-center gap-x-0.5 w-fit text-xs link-under-line text-type-black-primary'}
          onClick={handleFilterOpen}
          id="toggle-filters"
          aria-label="Toggle Filters"
        >
          <span class="filters__toggle before:content-show lg-max:before:hidden text-xs">Filters</span>
          <span className="sr-only paragraph-xs">
            {activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
          </span>
        </button>
        <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
      </div>

      <div className={'sr-only'}>
        <ProductCount />
      </div>

      <div className={'lg-max:hidden'}>
        <GridLayoutToggle gridCols={gridCols} setGridCols={setGridCols} />
      </div>
    </div>
  )
}
